import React, { useEffect, useRef } from 'react';
import { formatPrice } from '../../../services/formatPrice';
import { TextInput } from '../../Form';
import { FormFieldItem } from './FormFieldItem';
import Label from './Label';

function getLabel(label, price, currency, locale, showPayWhatYouWantPrice) {
  if (Number(price <= 0)) {
    if (showPayWhatYouWantPrice) {
      return `${label} (${currency.toUpperCase()})`;
    } else {
      return `${label}`;
    }
  }

  if (showPayWhatYouWantPrice) {
    const formattedPrice = formatPrice({
      amount: price,
      currency: currency,
      locale,
    });

    return `${label} (${formattedPrice}+)`;
  } else {
    return `${label}`;
  }
}

const PayWhatYouWantField = ({
  payWhatYouWantText,
  price,
  currency,
  locale,
  showPayWhatYouWantPrice,
  payWhatYouWantPlaceholderText,
  value,
  onChange,
  onBlur,
}) => {
  const node = useRef();

  // This is a hack to prevent the input from scrolling the page when the user
  // scrolls the mouse wheel over the input.
  useEffect(() => {
    const handleScroll = () => {
      node.current.blur();
    };

    if (node.current) {
      node.current.addEventListener('wheel', handleScroll, { passive: true });
    }
  }, [node]);

  return (
    <FormFieldItem className="cp_form-item">
      <Label htmlFor="payWhatYouWant" className="cp_form-label">
        {getLabel(payWhatYouWantText, price, currency, locale, showPayWhatYouWantPrice)}
      </Label>

      <div className="cp_paywhatyouwant-input flex items-center gap-x-2 w-1/2">
        <TextInput
          innerRef={node}
          className="cp_form-textinput"
          id="payWhatYouWant"
          name="payWhatYouWant"
          type="number"
          placeholder={payWhatYouWantPlaceholderText}
          value={value}
          onKeyDown={e => {
            if (e.key === 'e' || e.key === 'E') {
              e.preventDefault();
            }
          }}
          onChange={e => {
            const value = e.target.value;

            // Allow numbers, a single dot or comma for decimal, and no more than two decimals
            const newValue = value
              .replace(/[^\d.,]+/, '') // Remove any character that is not a digit, a period, or a comma
              .replace(/(\.\d{2})\d+|(\,\d{2})\d+/, '$1$2') // Allow only two digits after the dot or comma
              .replace(/(\d+)([.,])(\d{2}).*/, '$1$2$3'); // Remove any characters after two decimals

            onChange(newValue);
          }}
          onBlur={onBlur}
        />
      </div>
    </FormFieldItem>
  );
};

export default PayWhatYouWantField;
